export const TERRATALK_LIVE_ROUTES = {
  LOBBY: {
    NAME: "terratalkLiveLobby",
    PATH: "/live/lobby"
  }
};
